import { render, staticRenderFns } from "./Switched.vue?vue&type=template&id=53ebfe32&scoped=true"
import script from "./Switched.vue?vue&type=script&lang=js"
export * from "./Switched.vue?vue&type=script&lang=js"
import style0 from "./Switched.vue?vue&type=style&index=0&id=53ebfe32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ebfe32",
  null
  
)

export default component.exports